import { render, staticRenderFns } from "./AdressBook.vue?vue&type=template&id=74973d2c&scoped=true&"
import script from "./AdressBook.vue?vue&type=script&lang=js&"
export * from "./AdressBook.vue?vue&type=script&lang=js&"
import style0 from "./AdressBook.vue?vue&type=style&index=0&id=74973d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74973d2c",
  null
  
)

export default component.exports